import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading } from "../components/Common";

export default function Assessments() {
  const [items, setItems] = useState(null);
  const [subjectFilter, setSubjectFilter] = useState("");

  useEffect(() => {
    api.assessments().then(({ data }) => setItems(data));
  }, []);

  if (items === null) return <Loading />;

  const subjects = Array.from(new Set(items.map((r) => r.subject_name).filter(Boolean))).sort();
  const filtered = subjectFilter ? items.filter((r) => r.subject_name === subjectFilter) : items;

  return (
    <div data-testid="assessments-page">
      <PageHeader
        kicker="Continuous Assessment"
        title="Assessments"
        subtitle={`${items.length} published assessments across ${subjects.length} subjects · current academic year.`}
      />
      <div className="mb-4 flex flex-wrap gap-3">
        <select
          value={subjectFilter}
          onChange={(e) => setSubjectFilter(e.target.value)}
          className="px-3 py-2 border border-slate-200 rounded-md text-sm bg-white"
          data-testid="assessments-subject-filter"
        >
          <option value="">All subjects</option>
          {subjects.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
      </div>
      <Section>
        <DataTable
          testId="assessments-table"
          columns={[
            { key: "title", label: "Assessment", render: (r) => (
              <div>
                <div className="font-semibold text-slate-800">{r.title}</div>
                {r.term && <div className="text-xs text-slate-500">{r.term} · {r.type}</div>}
              </div>
            ) },
            { key: "subject", label: "Subject", render: (r) => r.subject_name || <span className="text-slate-400">N/A</span> },
            { key: "class", label: "Class", render: (r) => (
              <div>
                <div className="text-slate-700">{r.class_name || <span className="text-slate-400">N/A</span>}</div>
                {r.year_group && <div className="text-xs text-slate-500">{r.year_group}</div>}
              </div>
            ) },
            { key: "teacher", label: "Teacher", render: (r) => r.teacher_name || <span className="text-slate-400">N/A</span> },
            { key: "date", label: "Date" },
            { key: "max_score", label: "Max", render: (r) => <span className="mono">{r.max_score}</span> },
            { key: "completion", label: "Completion", render: (r) => (
              r.completion_pct == null
                ? <span className="text-slate-400 text-xs">Awaiting marks</span>
                : <span className="mono">{r.completion_pct}%</span>
            ) },
          ]}
          rows={filtered}
        />
      </Section>
    </div>
  );
}
